import { useState } from 'react'
import { Copy, CheckCircle } from 'lucide-react'

export const CopyableLabel = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex items-center space-x-2 w-full max-w-[220px]">{children}</div>
}

const CopyTextButton = ({ text, className }: { text: string; className?: string }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    if (!text) {
      return
    }

    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true)
        setTimeout(() => {
          setCopied(false)
        }, 2000)
      })
      .catch((err: unknown) => {
        console.error('Failed to copy text', err)
      })
  }

  return (
    <button
      onClick={handleCopy}
      className={`h-9 w-9 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${className} ${
        copied
          ? 'border border-gray-200 bg-gray-100 text-secondary-foreground hover:bg-gray-100'
          : 'border border-input bg-background hover:bg-accent hover:text-accent-foreground'
      }`}
    >
      {copied ? <CheckCircle className="h-4 w-4 text-green-500" /> : <Copy className="h-4 w-4" />}
    </button>
  )
}

const Text = ({ children }) => {
  return (
    <div className="flex-1 bg-gray-100 border border-gray-200 rounded-md px-3 py-1 font-mono truncate min-h-9">
      {children}
    </div>
  )
}

CopyableLabel.Text = Text
CopyableLabel.CopyTextButton = CopyTextButton
